import { Injectable } from '@angular/core';
import { Utils } from 'src/app/shared/utils/utils';
import { AuthModule } from '../auth.module';

@Injectable({
  providedIn: AuthModule
})
export class TokenUsageCounterService {

  tokenUsageCounterKey = "KeynetixPortal.TokenUsageCounter";

  constructor() { }

  getTokenUsageCounter(): number {
    let usageCounterString: string = localStorage.getItem(
      this.tokenUsageCounterKey
    );
    if (Utils.isNullOrWhiteSpaceString(usageCounterString)) {
      usageCounterString = "0";
    }
    return Number.parseInt(usageCounterString, 10);
  }

  incrementTokenUsageCounter(): number {
    let counter = this.getTokenUsageCounter();
    ++counter;
    localStorage.setItem(this.tokenUsageCounterKey, counter.toString());
    return counter;
  }

  // Decrement the token usage counter by 1 (unless already zero) and return the updated value
  decrementTokenUsageCounter(): number {
    let counter = this.getTokenUsageCounter();
    if (counter > 0) {
      --counter;
      localStorage.setItem(this.tokenUsageCounterKey, counter.toString());
    }
    return counter;
  }

  clear() {
    localStorage.removeItem(this.tokenUsageCounterKey);
  }
}
